import * as React from 'react'
import IconType from './iconType'

const BundlesIcon = (props: IconType) => {

  return (
    <svg
      className={`${props.className}`}
      height={props.h}
      width={props.w}
      viewBox="0 0 512 512"
      >
      <path d="M192 32C192 14.33 206.3 0 224 0H288C305.7 0 320 14.33 320 32V49.64C387.8 70.65 441.4 124.2 462.4 192H480C497.7 192 512 206.3 512 224V288C512 305.7 497.7 320 480 320H462.4C441.4 387.8 387.8 441.4 320 462.4V480C320 497.7 305.7 512 288 512H224C206.3 512 192 497.7 192 480V462.4C124.2 441.4 70.65 387.8 49.64 320H32C14.33 320 0 305.7 0 288V224C0 206.3 14.33 192 32 192H49.64C70.65 124.2 124.2 70.65 192 49.64V32zM280 88V40H232V88H280zM100.5 192.3C116 194.5 128 207.9 128 224V288C128 304.1 116 317.5 100.5 319.7C117.5 361.3 150.7 394.5 192.3 411.5C194.5 395.1 207.9 384 224 384H288C304.1 384 317.5 395.1 319.7 411.5C361.3 394.5 394.5 361.3 411.5 319.7C395.1 317.5 384 304.1 384 288V224C384 207.9 395.1 194.5 411.5 192.3C394.5 150.7 361.3 117.5 319.7 100.5C317.5 116 304.1 128 288 128H224C207.9 128 194.5 116 192.3 100.5C150.7 117.5 117.5 150.7 100.5 192.3V192.3zM424 232V280H472V232H424zM232 424V472H280V424H232zM40 232V280H88V232H40z"
      />
    </svg>
  )
}

export default BundlesIcon
